export default __webpack_public_path__ + "static/media/first_shooting.4563b9ca.png";